import { useEffect } from "react";
import "./css/slider.css";
import image1 from "./img/Integrations/zoho-quickbooks.png";
import image2 from "./img/Integrations/service-icon-02.png";
import image3 from "./img/Integrations/service-icon-03.png";
import image4 from "./img/Integrations/service-icon-04.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft, faChevronRight, faArrowRight } from "@fortawesome/free-solid-svg-icons";

const ProductSlider = () => {
  useEffect(() => {
    const scrollRow = document.getElementById("autoScrollRow");
    const scrollContainer = document.getElementById("hoverPause");
    let intervalId;

    function startAutoScroll() {
      intervalId = setInterval(() => {
        scrollRight();
      }, 7000);
    }

    function stopAutoScroll() {
      clearInterval(intervalId);
    }

    function scrollRight() {
      const firstCard = scrollRow.querySelector(".service-card");
      if (!firstCard) return;
      const cardWidth = firstCard.offsetWidth + 1;

      scrollRow.style.transition = "transform 0.3s ease-in-out";
      scrollRow.style.transform = `translateX(-${cardWidth}px)`;

      setTimeout(() => {
        scrollRow.appendChild(firstCard);
        scrollRow.style.transition = "none";
        scrollRow.style.transform = "translateX(0)";
      }, 100);
    }

    function scrollLeft() {
      const cards = scrollRow.querySelectorAll(".service-card");
      const lastCard = cards[cards.length - 1];
      if (!lastCard) return;
      const cardWidth = lastCard.offsetWidth + 16;

      scrollRow.style.transition = "none";
      scrollRow.insertBefore(lastCard, cards[0]);
      scrollRow.style.transform = `translateX(-${cardWidth}px)`;

      requestAnimationFrame(() => {
        scrollRow.style.transition = "transform 0.6s ease-in-out";
        scrollRow.style.transform = "translateX(0)";
      });
    }


    const leftBtn = document.querySelector(".scroll-arrow-left");
    const rightBtn = document.querySelector(".scroll-btn.right");

    leftBtn.onclick = () => {
      stopAutoScroll();
      scrollLeft();
      startAutoScroll();
    };

    rightBtn.onclick = () => {
      stopAutoScroll();
      scrollRight();
      startAutoScroll();
    };


    scrollContainer.addEventListener("mouseenter", stopAutoScroll);
    scrollContainer.addEventListener("mouseleave", startAutoScroll);

    let startX;
    scrollContainer.addEventListener("touchstart", (e) => {
      startX = e.touches[0].clientX;
      stopAutoScroll();
    });

    scrollContainer.addEventListener("touchend", (e) => {
      const endX = e.changedTouches[0].clientX;
      if (startX - endX > 30) {
        scrollRight();
      }
      startAutoScroll();
    });


    startAutoScroll();


    return () => {
      stopAutoScroll();
      leftBtn.onclick = null;
      rightBtn.onclick = null;
      scrollContainer.removeEventListener("mouseenter", stopAutoScroll);
      scrollContainer.removeEventListener("mouseleave", startAutoScroll);
      scrollContainer.removeEventListener("touchstart", () => { });
      scrollContainer.removeEventListener("touchend", () => { });
    };
  }, []);

  return (
    <>

      <div className="ti-arrow-container">
        <div className="arrows ti-arrow">
          <button className="scroll-btn left scroll-arrow-left arrow-btn">
            <FontAwesomeIcon icon={faChevronLeft} />
          </button>

          <button className="scroll-btn right arrow-btn">
            <FontAwesomeIcon icon={faChevronRight} />
          </button>
        </div>
      </div>

      <div
        className="mt-6 mb-5  auto-scroll-container overflow-hidden main-content"
      >

        <h1 className="center-label auto-show">Tiara Integrations</h1>

        <div className="scroll-wrapper p-2 m-1 auto-scroll-wrapper" id="hoverPause">
          <div className="scrolling-row d-flex" id="autoScrollRow">

            <div className="service-card flex-shrink-0 p-2">
              <div className="service-item first-service">
                <img src={image1} alt="Zoho QuickBooks" />
                <h4>TallyPrime Integration</h4>
                <p>Integrates from Zoho CRM to Quick Books Online</p>
              </div>
            </div>

            <div className="service-card flex-shrink-0 p-2">
              <div className="service-item second-service">
                <img src={image2} alt="ZohoBooks" />
                <h4>ZohoBooks Integration</h4>
                <p>
                  Zoho Books integration can streamline everything from invoicing
                  and payments to inventory, CRM, and tax compliance
                </p>
              </div>
            </div>

            <div className="service-card flex-shrink-0 p-2">
              <div className="service-item third-service">
                <img src={image3} alt="QuickBooks" />
                <h4>QuickBooks Integration</h4>
                <p>
                  QuickBooks integration is super useful to sync accounting with
                  other systems like e-commerce, CRM, payroll, inventory
                </p>
              </div>
            </div>

            <div className="service-card flex-shrink-0 p-2">
              <div className="service-item fourth-service">
                <img src={image4} alt="WhatsApp" />
                <h4>WhatsApp Integration</h4>
                <p>
                  Integrate WhatsApp into a business system (like a CRM, website,
                  or customer support)
                </p>
              </div>
            </div>
          </div>
        </div>


      </div>

    </>
  );
};

export default ProductSlider;


// import { useEffect, useRef } from "react";
// import "./css/dataIntegration.css";

// import integration1 from "./img/Integrations/integration1.jpeg"
// import integration2 from "./img/Integrations/integration2.jpeg"
// import integration3 from "./img/Integrations/integration3.jpeg"
// import integration4 from "./img/Integrations/integration4.jpeg"
// import integration5 from "./img/Integrations/integration5.jpeg"
// // Import the FontAwesome component
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// // Import the specific icons used in the UI
// import {
//   faChevronLeft,
//   faChevronRight,
//   faCheckCircle,
//   faShieldAlt,
//   faStar,
//   faCloud,
//   faPlug,
//   faDatabase,
//   faCogs,
//   faLaptopCode
// } from "@fortawesome/free-solid-svg-icons";
// import { NavLink } from "react-router-dom";

// const ProductSlider = () => {
//   const scrollRowRef = useRef(null);
//   const scrollContainerRef = useRef(null);
//   const intervalIdRef = useRef(null);

//   useEffect(() => {
//     const scrollRow = scrollRowRef.current;
//     const scrollContainer = scrollContainerRef.current;

//     if (!scrollRow || !scrollContainer) return;

//     let touchStartX = 0;
//     let touchEndX = 0;

//     function startAutoScroll() {
//       intervalIdRef.current = setInterval(() => {
//         scrollRight();
//       }, 7000);
//     }

//     function stopAutoScroll() {
//       if (intervalIdRef.current) {
//         clearInterval(intervalIdRef.current);
//       }
//     }

//     function scrollRight() {
//       const firstCard = scrollRow.querySelector(".service-card");
//       if (!firstCard) return;

//       const cardWidth = firstCard.offsetWidth + 16;

//       scrollRow.style.transition =
//         "transform 0.4s cubic-bezier(0.25, 0.8, 0.25, 1)";
//       scrollRow.style.transform = `translateX(-${cardWidth}px)`;

//       setTimeout(() => {
//         scrollRow.appendChild(firstCard);
//         scrollRow.style.transition = "none";
//         scrollRow.style.transform = "translateX(0)";
//       }, 400);
//     }

//     function scrollLeft() {
//       const cards = scrollRow.querySelectorAll(".service-card");
//       if (!cards.length) return;

//       const lastCard = cards[cards.length - 1];
//       const cardWidth = lastCard.offsetWidth + 16;

//       scrollRow.style.transition = "none";
//       scrollRow.insertBefore(lastCard, cards[0]);
//       scrollRow.style.transform = `translateX(-${cardWidth}px)`;

//       requestAnimationFrame(() => {
//         scrollRow.style.transition =
//           "transform 0.4s cubic-bezier(0.25, 0.8, 0.25, 1)";
//         scrollRow.style.transform = "translateX(0)";
//       });
//     }

//     // ===== SWIPE SUPPORT =====
//     function handleTouchStart(e) {
//       touchStartX = e.changedTouches[0].screenX;
//     }

//     function handleTouchEnd(e) {
//       touchEndX = e.changedTouches[0].screenX;
//       handleSwipe();
//     }

//     function handleSwipe() {
//       const swipeDistance = touchEndX - touchStartX;

//       if (Math.abs(swipeDistance) < 50) return;

//       stopAutoScroll();

//       if (swipeDistance < 0) {
//         scrollRight(); // swipe left
//       } else {
//         scrollLeft(); // swipe right
//       }

//       startAutoScroll();
//     }
//     // ==========================

//     // Arrow buttons
//     window.manualScrollLeft = () => {
//       stopAutoScroll();
//       scrollLeft();
//       startAutoScroll();
//     };

//     window.manualScrollRight = () => {
//       stopAutoScroll();
//       scrollRight();
//       startAutoScroll();
//     };

//     // Hover pause
//     scrollContainer.addEventListener("mouseenter", stopAutoScroll);
//     scrollContainer.addEventListener("mouseleave", startAutoScroll);

//     // Touch events
//     scrollContainer.addEventListener("touchstart", handleTouchStart);
//     scrollContainer.addEventListener("touchend", handleTouchEnd);

//     startAutoScroll();

//     return () => {
//       stopAutoScroll();

//       scrollContainer.removeEventListener("mouseenter", stopAutoScroll);
//       scrollContainer.removeEventListener("mouseleave", startAutoScroll);
//       scrollContainer.removeEventListener("touchstart", handleTouchStart);
//       scrollContainer.removeEventListener("touchend", handleTouchEnd);

//       delete window.manualScrollLeft;
//       delete window.manualScrollRight;
//     };
//   }, []);

//   return (
//     <div className="di-page-wrapper">
//       {/* Hero Section */}
//       <section className="di-hero py-5">
//         <div className="container">
//           <div className="row align-items-center">
//             <div className="col-lg-12 DataInter-header">

//               <h1 className="fw-bold mb-2 di-gradient-text">What is Data Integration?</h1>
//               <p className="mb-3 dataInterPara">
//                 Data Integration is the process of connecting multiple applications,
//                 systems, and databases to ensure seamless data flow across your organization.
//                 It eliminates isolated data, reduces manual effort, and enables real-time decision-making.
//               </p>
//               <p className="mb-4 dataInterPara">
//                 In today’s digital world, businesses use multiple platforms (CRM, ERP, Accounting, HR, E-commerce).
//                 Without integration, these systems operate independently, leading to inconsistent data and operational inefficiencies.
//               </p>
//               <div className="di-highlight-box p-3 border-start border-4 border-primary bg-white shadow-sm rounded">
//                 <p className="fw-semibold m-0 text-dark">
//                   We help businesses unify their systems through secure and scalable integrations.
//                 </p>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Slider Section */}
//       <section className="di-slider-section py-2 bg-light">
//         <div className="container position-relative">
//           <div className="d-flex justify-content-between align-items-center mb-4">
//             <h3 className="fw-bold m-0">Integrations</h3>
//             <div className="di-arrows">
//               <button className="di-scroll-btn" onClick={() => window.manualScrollLeft()}>
//                 <FontAwesomeIcon icon={faChevronLeft} />
//               </button>
//               <button className="di-scroll-btn" onClick={() => window.manualScrollRight()}>
//                 <FontAwesomeIcon icon={faChevronRight} />
//               </button>
//             </div>
//           </div>

//           <div className="di-auto-scroll-container overflow-hidden" ref={scrollContainerRef}>
//             <div className="di-scrolling-row d-flex gap-3" ref={scrollRowRef}>
//               {[
//                 {
//                   img: integration5,
//                   title: "CharmHealth Integration",
//                   desc: "Integrates from CharmHealth to QuickBooks Online",
//                   path: "/charmhealth-quickbooks"
//                 },
//                 { img: integration2, title: "TallyPrime Integration", desc: "Integrates from Zoho CRM to QuickBooks Online" },
//                 { img: integration1, title: "ZohoBooks Integration", desc: "Streamline invoicing, payments, inventory and CRM." },
//                 { img: integration3, title: "QuickBooks Integration", desc: "Sync accounting with CRM, payroll and inventory." },
//                 { img: integration4, title: "WhatsApp Integration", desc: "Connect WhatsApp with CRM or support systems." }
//               ].map((service, index) => (
//                 <div className="service-card flex-shrink-0" key={index}>
//                   {service.path ? (
//                     <NavLink to={service.path} className="text-decoration-none text-dark">
//                       <div className="di-service-item card h-100 shadow-sm border-0 rounded-4 p-4 text-center">
//                         <div className="di-icon-wrapper mx-auto mb-3">
//                           <img src={service.img} alt={service.title} className="img-fluid img-intergation" />
//                         </div>
//                         <h5 className="fw-bold">{service.title}</h5>
//                         <p className="text-muted small m-0">{service.desc}</p>
//                       </div>
//                     </NavLink>
//                   ) : (
//                     <div className="di-service-item card h-100 shadow-sm border-0 rounded-4 p-4 text-center">
//                       <div className="di-icon-wrapper mx-auto mb-3">
//                         <img src={service.img} alt={service.title} className="img-fluid" />
//                       </div>
//                       <h5 className="fw-bold">{service.title}</h5>
//                       <p className="text-muted small m-0">{service.desc}</p>
//                     </div>
//                   )}
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Services Section */}
//       <section className="py-5 di-services-bg">
//         <div className="container">
//           <div className="text-center mb-5">
//             <h2 className="fw-bold di-gradient-text">Our Data Integration Services</h2>
//           </div>

//           <div className="row g-4 justify-content-center">
//             {[
//               {

//                 title: "Application-to-Application Integration",
//                 desc: "We connect cloud and on-premise systems to enable smooth data exchange.",
//                 listTitle: "Examples:",
//                 items: [
//                   "CRM ↔ ERP Integration",
//                   "E-commerce ↔ Accounting and Inventory Integration",
//                   "HR ↔ Payroll Integration",
//                   "Inventory ↔ Order Management"
//                 ],
//                 icon: faCloud
//               },
//               {

//                 title: "API Integration Services",
//                 desc: "We design and implement REST and Webhook-based integrations to connect your business applications in real time.",
//                 listTitle: "Benefits:",
//                 items: [
//                   "Secure API authentication",
//                   "Real-time synchronization",
//                   "Scalable architecture",
//                   "Error handling & monitoring"
//                 ],
//                 icon: faPlug
//               },
//               {

//                 title: "Data Migration Services",
//                 desc: "We securely migrate data from legacy systems to modern platforms.",
//                 listTitle: "Includes:",
//                 items: [
//                   "Data mapping & cleansing",
//                   "Validation & testing",
//                   "Data Reconciliation",
//                   "Post-migration support"
//                 ],
//                 icon: faDatabase
//               },
//               {

//                 title: "Workflow Automation",
//                 desc: "Automate repetitive business processes and reduce manual intervention.",
//                 listTitle: "Use Cases:",
//                 items: [
//                   "Order to Invoice automation",
//                   "Lead to Customer automation",
//                   "Ticket auto-assignment",
//                   "Approval workflow automation"
//                 ],
//                 icon: faCogs
//               }
//             ].map((service, idx) => (
//               <div className="col-lg-6 col-md-12" key={idx}>
//                 <div className="di-service-card card h-100 border-0 p-4 rounded-4 shadow-sm">
//                   <div className="di-service-step">{service.step}</div>
//                   <div className="d-flex align-items-center gap-3 mb-3">
//                     <div className="di-service-icon-box flex-shrink-0">
//                       <FontAwesomeIcon icon={service.icon} className="fs-4 text-primary" />
//                     </div>
//                     <h4 className="fw-bold m-0">{service.title}</h4>
//                   </div>
//                   <p className="text-muted mb-4">{service.desc}</p>

//                   <div className="di-service-list-container mt-auto">
//                     <h6 className="fw-bold text-dark mb-3">{service.listTitle}</h6>
//                     <ul className="di-inner-list">
//                       {service.items.map((item, i) => (
//                         <li key={i}>
//                           <FontAwesomeIcon icon={faCheckCircle} className="text-success me-2 small" />
//                           {item}
//                         </li>
//                       ))}
//                     </ul>
//                   </div>
//                 </div>
//               </div>
//             ))}

//             {/* Service 5 */}
//             <div className="col-lg-12 mt-4">
//               <div className="di-featured-service card border-0 p-5 rounded-4 shadow-lg text-white position-relative overflow-hidden d-flex flex-md-row align-items-center gap-4">

//                 <div className="position-relative z-1 flex-grow-1">
//                   <div className="d-flex flex-md-row align-items-center gap-3">
//                     <FontAwesomeIcon icon={faLaptopCode} className="fs-1 mb-2 text-warning" />
//                     <h3 className="fw-bold mb-2 text-black customerInter ">Custom Integration Solutions</h3>
//                   </div>

//                   <p className="m-0 fs-5 textwhite text-muted customerInterP">
//                     Every business is unique. We design custom integration solutions tailored to your business processes and system architecture.
//                   </p>
//                 </div>
//                 <div className="di-glass-overlay"></div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Benefits Section */}
//       <section className="py-5 bg-light">
//         <div className="container">
//           <div className="text-center mb-5">
//             <h2 className="fw-bold mb-3"><FontAwesomeIcon icon={faStar} className="text-warning me-2" /> Benefits Of Data Integration</h2>
//           </div>
//           <div className="row g-3">
//             {[
//               "Eliminate manual data entry", "Reduce human errors",
//               "Real-time data visibility", "Improve operational efficiency",
//               "Faster decision-making", "Better customer experience",
//               "Centralized reporting", "Increased productivity"
//             ].map((item, i) => (
//               <div className="col-lg-3 col-md-4 col-sm-6" key={i}>
//                 <div className="di-benefit-card p-3 bg-white rounded-3 shadow-sm d-flex align-items-center gap-2 border-start border-3 border-success h-100">
//                   <FontAwesomeIcon icon={faCheckCircle} className="text-success flex-shrink-0" />
//                   <span className="fw-medium text-dark small">{item}</span>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Industries & Technologies Section */}
//       <section className="py-5">
//         <div className="container">
//           <div className="row g-5">
//             {/* Industries */}
//             <div className="col-lg-6">
//               <div className="p-4 rounded-4 bg-light h-100 border">
//                 <h3 className="fw-bold mb-4">Industries We Serve</h3>
//                 <div className="d-flex flex-wrap gap-2">
//                   {[
//                     { name: "E-commerce & Retail", icon: "fa-cart-shopping", color: "retail" },
//                     { name: "Finance & Accounting", icon: "fa-dollar-sign", color: "finance" },
//                     { name: "Healthcare", icon: "fa-heart-pulse", color: "health" },
//                     { name: "Manufacturing", icon: "fa-industry", color: "manufacturing" },
//                     { name: "SaaS & Technology", icon: "fa-cloud", color: "saas" },
//                     { name: "Logistics & Supply Chain", icon: "fa-truck", color: "logistics" },
//                     { name: "Professional Services", icon: "fa-briefcase", color: "services" },
//                   ].map((ind, i) => (
//                     <span
//                       key={i}
//                       className={`di-tech-badge industry-badge industry-${ind.color}`}
//                     >
//                       <i className={`fa-solid ${ind.icon} me-2`}></i>
//                       {ind.name}
//                     </span>
//                   ))}
//                 </div>
//               </div>
//             </div>

//             {/* Technologies */}
//             <div className="col-lg-6">
//               <div className="p-4 rounded-4 bg-light h-100 border">
//                 <h3 className="fw-bold mb-4">Technologies We Work With</h3>
//                 <div className="d-flex flex-wrap gap-2">
//                   {[
//                     { name: "REST APIs & Webhooks", icon: "fa-link" },
//                     { name: "JSON / XML Data Formats", icon: "fa-code" },
//                     { name: "ETL Tools", icon: "fa-database" },
//                     { name: "Cloud Platforms (AWS, Azure)", icon: "fa-cloud" },
//                     { name: "Databases (MySQL, PostgreSQL, MongoDB)", icon: "fa-server" },
//                     { name: "Integration Platforms", icon: "fa-network-wired" },
//                     { name: "Custom Middleware Development", icon: "fa-cogs" },
//                   ].map((tech, i) => (
//                     <span key={i} className="di-tech-badge tech-badge">
//                       <i className={`fa-solid ${tech.icon} me-2`}></i> {tech.name}
//                     </span>
//                   ))}
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/*  Security & Why Choose Us Section */}
//       <section className="py-5 bg-light">
//         <div className="container py-4">
//           <div className="row g-5 align-items-center">



//             {/* Right Side: Security Trust Card */}
//             <div className="col-lg-5">
//               <div className="di-trust-card p-5 rounded-4 shadow-lg text-white position-relative overflow-hidden h-100">
//                 <div className="position-relative z-1">
//                   <div className="di-shield-icon bg-white text-primary mb-4 shadow-sm">
//                     <FontAwesomeIcon icon={faShieldAlt} className="fs-3" />
//                   </div>
//                   <h3 className="fw-bold mb-3">Enterprise-Grade Security</h3>
//                   <p className="text-white-50 mb-4 small">
//                     We follow strict industry protocols to ensure your data is protected at every single touchpoint.
//                   </p>

//                   <ul className="list-unstyled mb-0 d-flex flex-column gap-3 mt-4">
//                     {[
//                       "Secure API authentication",
//                       "Encrypted data transfer (HTTPS/SSL)",
//                       "Strict access control mechanisms",
//                       "Data privacy & compliance (GDPR, SOC2)"
//                     ].map((item, i) => (
//                       <li key={i} className="d-flex align-items-start gap-3 di-trust-list-item">
//                         <FontAwesomeIcon icon={faCheckCircle} className="text-success mt-1" />
//                         <span className="fw-medium text-white-75">{item}</span>
//                       </li>
//                     ))}
//                   </ul>
//                 </div>
//                 {/* Decorative background glow */}
//                 <div className="di-trust-glow"></div>
//               </div>
//             </div>
//             {/* Left Side: Why Choose Us */}
//             <div className="col-lg-7">

//               <h2 className="fw-bold mb-3">Why choose us?</h2>
//               <p className="text-muted mb-5 pe-lg-5">
//                 We bring years of expertise in building resilient, scalable, and seamless data pipelines that empower your business to move faster and smarter.
//               </p>

//               <div className="row g-4">
//                 {[
//                   "Experienced Integration Specialists",
//                   "Proven Track Record",
//                   "Scalable & Secure Architecture",
//                   "Real-time Data Synchronization",
//                   "Dedicated Support Team",
//                   "Customizable Solutions"
//                 ].map((item, i) => (
//                   <div className="col-md-6" key={i}>
//                     <div className="di-advantage-card d-flex align-items-center gap-3 p-3 bg-white rounded-3 shadow-sm border border-light">
//                       <div className="di-icon-circle">
//                         <FontAwesomeIcon icon={faCheckCircle} />
//                       </div>
//                       <span className="fw-bold text-dark small m-0">{item}</span>
//                     </div>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>
//     </div>
//   );
// };

// export default ProductSlider;
